



























import dateFormat from 'date-fns/format'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import Coupon from '@spa/components/pages/mypage/coupon/models/coupon'

@Component({})
export default class CouponListItem extends Vue {
  @Prop({ required: true })
  coupon: Coupon

  formatDate(date: Date): string {
    return dateFormat(date, 'YYYY/M/D HH:mm')
  }
}
